module.exports = __webpack_public_path__ + "static/media/externalBarn_5.5143816b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/outskirts/barn/externalBarn_5.png
// module id = 1309
// module chunks = 3